import Vue from "vue";
import vueHeadful from "vue-headful";
import VueLazyLoad from "vue-lazyload";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";

import VueSilentbox from "vue-silentbox";

import App from "./App.vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import Loading from "./plugins/delayedLoader";
import store from "./store/index";

import { description } from "../package.json";

import router from "./router/router";

// remove old caching service workers
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let reg of registrations) {
            reg.unregister();
            console.log("unregistered service worker");
        }
    });
}

// plugin setup
Vue.use(VueSilentbox);
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueLazyLoad);
Vue.use(Loading, {
    delay: 500,
    color: "white",
    backgroundColor: "black",
    opacity: 0.3,
    zIndex: 9999,
});

Vue.component("VueHeadful", vueHeadful);

Vue.mixin({
    data() {
        return {
            get appName() {
                return description;
            },
        };
    },
});

Vue.config.productionTip = false;

new Vue({
    el: "#app",
    render: (h) => h(App),
    store,
    router,
});
